<template>
    <div v-if="Object.keys(itemDetailActivity).length">
        <data-table
            v-if="itemDetailActivity.newData"
            :headers="defaultHeaders"
            :item-detail-activity="itemDetailActivity"
            module="quoteRequest" />
        <template v-if="itemDetailActivity.newData && itemDetailActivity.newData['$set'].positions">
            <hr class="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" >
            <span class="font-bold">
                Thông tin tuyến cũ
            </span>
            <div class="w-full">
                <hts-time-line :items="itemDetailActivity.oldData.positions">
                    <template #content="{ item }">
                        <div class="flex-col w-full">
                            <span>
                                {{ item.nodeName }}
                            </span>
                            <div>
                                <table class="min-w-full text-left divide-y divide-gray-200 dark:divide-gray-600">
                                    <thead class="bg-gray-50 dark:bg-gray-700">
                                        <tr>
                                            <th class="w-1/4">
                                                {{ $t('labels.task') }}
                                            </th>
                                            <th class="w-1/4">
                                                {{ $t('labels.performedBy') }}
                                            </th>
                                            <th class="w-1/4">
                                                {{ $t('labels.activateVehicleStatus') }}
                                            </th>
                                            <th class="w-1/4">
                                                {{ $t('labels.completionTimeHour') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white dark:bg-gray-800">
                                        <tr
                                            v-for="(task, index) in item.tasks"
                                            :key="index">
                                            <td>
                                                <p class="font-bold">
                                                    {{ task.taskName }}
                                                </p>
                                                <p class="text-sm opacity-75 italic">
                                                    {{ task.businessName }}
                                                </p>
                                            </td>
                                            <td>
                                                <hts-form-button
                                                    v-if="['HEADWAY_DRIVER', 'HEADWAY', 'CUSTOMER'].includes(task.responsibleForImplementation)"
                                                    size="small">
                                                    <span>
                                                        {{ labelResponsibleForImplementation(task.responsibleForImplementation) }}
                                                    </span>
                                                </hts-form-button>
                                            </td>
                                            <td>
                                                <hts-form-button
                                                    v-if="['HAVE_GOODS', 'HAVE_CONTAINER', 'EMPTY_VEHICLE'].includes(task.activateVehicleStatus)"
                                                    size="small"
                                                    text-transform="lowercase">
                                                    <span>
                                                        {{ activateVehicleStatusLabel(task.activateVehicleStatus) }}
                                                    </span>
                                                </hts-form-button>
                                            </td>
                                            <td>
                                                <hts-form-input
                                                    v-model="task.timeComplete"
                                                    size="small"
                                                    type="number"
                                                    autocomplete="off"
                                                    disabled
                                                    name="completionTime"
                                                    :prop="'task' + index" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>
                </hts-time-line>
            </div>
            <span class="font-bold">
                Thông tin tuyến mới
            </span>
            <div class="w-full">
                <hts-time-line :items="itemDetailActivity.newData['$set'].positions">
                    <template #content="{ item }">
                        <div class="flex-col w-full">
                            <span>
                                {{ item.nodeName }}
                            </span>
                            <div>
                                <table class="min-w-full text-left divide-y divide-gray-200 dark:divide-gray-600">
                                    <thead class="bg-gray-50 dark:bg-gray-700">
                                        <tr>
                                            <th class="w-1/4">
                                                {{ $t('labels.task') }}
                                            </th>
                                            <th class="w-1/4">
                                                {{ $t('labels.performedBy') }}
                                            </th>
                                            <th class="w-1/4">
                                                {{ $t('labels.activateVehicleStatus') }}
                                            </th>
                                            <th class="w-1/4">
                                                {{ $t('labels.completionTimeHour') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white dark:bg-gray-800">
                                        <tr
                                            v-for="(task, index) in item.tasks"
                                            :key="index">
                                            <td>
                                                <p class="font-bold">
                                                    {{ task.taskName }}
                                                </p>
                                                <p class="text-sm opacity-75 italic">
                                                    {{ task.businessName }}
                                                </p>
                                            </td>
                                            <td>
                                                <hts-form-button
                                                    v-if="['HEADWAY_DRIVER', 'HEADWAY', 'CUSTOMER'].includes(task.responsibleForImplementation)"
                                                    size="small">
                                                    <span>
                                                        {{ labelResponsibleForImplementation(task.responsibleForImplementation) }}
                                                    </span>
                                                </hts-form-button>
                                            </td>
                                            <td>
                                                <hts-form-button
                                                    v-if="['HAVE_GOODS', 'HAVE_CONTAINER', 'EMPTY_VEHICLE'].includes(task.activateVehicleStatus)"
                                                    size="small">
                                                    <span>
                                                        {{ activateVehicleStatusLabel(task.activateVehicleStatus) }}
                                                    </span>
                                                </hts-form-button>
                                            </td>
                                            <td>
                                                <hts-form-input
                                                    v-model="task.timeComplete"
                                                    size="small"
                                                    type="number"
                                                    autocomplete="off"
                                                    disabled
                                                    name="completionTime"
                                                    :prop="'task' + index" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>
                </hts-time-line>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
const { $formatters } = useNuxtApp()
const props = defineProps({
  itemDetailActivity: {
    type: Object,
    default: () => {}
  }
})
const store = $store()

const { itemDetailActivity } = toRefs(props)

const labelResponsibleForImplementation = (type: string) => {
  const workspaceName = store.system.workspace.name
  if (type === 'HEADWAY') {
    return workspaceName + ' - ' + $t('labels.other')
  }
  if (type === 'HEADWAY_DRIVER') {
    return workspaceName + ' - ' + $t('labels.driver')
  }
  if (type === 'CUSTOMER') {
    return $t('labels.customer')
  }
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}
const defaultHeaders: { [key: string]: any } = {
  quoteCode: {
    label: $t('labels.quote'),
    type: 'string'
  },
  customerName: {
    label: $t('labels.customer'),
    type: 'string'
  },
  contactName: {
    label: $t('labels.contact'),
    type: 'string'
  },
  businessOpportunityName: {
    label: $t('labels.businessOpportunity'),
    type: 'string'
  },
  commodityName: {
    label: $t('labels.commodity'),
    type: 'string'
  },
  workflowName: {
    label: $t('labels.workflow'),
    type: 'string'
  },
  contCategory: {
    label: $t('labels.cont'),
    valueFormatter: (data: number) => {
      if ($lodash.isNil(data)) {
        return null
      }
      return listLabelCont[data] || '...'
    }
  },
  vehicleCategoryName: {
    label: $t('labels.vehicleType'),
    type: 'string'
  },
  productivity: {
    label: $t('labels.productivityByMount'),
    type: 'number'
  },
  weightCommodity: {
    label: $t('labels.weightCommodityByKG1'),
    type: 'number'
  },
  request: {
    label: $t('labels.requestOther'),
    type: 'string'
  },
  status: {
    label: $t('labels.status'),
    type: 'status'
  },
  headContainer: {
    label: $t('labels.headContainer'),
    valueFormatter: (data: boolean | string) => {
      if (typeof data === 'boolean') {
        if (data) {
          return $t('labels.true')
        }
        return $t('labels.false')
      }
      return ''
    }
  },
  mergeContainer: {
    label: $t('labels.mergeContainer'),
    valueFormatter: (data: boolean | string) => {
      if (typeof data === 'boolean') {
        if (data) {
          return $t('labels.true')
        }
        return $t('labels.false')
      }
      return ''
    }
  }
}

const activateVehicleStatusLabel = (type: string) => {
  if (type === 'HAVE_GOODS') {
    return $t('labels.haveGoods')
  }
  if (type === 'HAVE_CONTAINER') {
    return $t('labels.haveContainer')
  }
  if (type === 'EMPTY_VEHICLE') {
    return $t('labels.emptyVehicle')
  }
}
</script>

<style scoped></style>
